import axios from "axios";
import { useQuery } from "@tanstack/react-query";
export const useGetDraftAndWorkflows = (draftId) => {
  return useQuery({
    queryKey: ["draft", draftId],
    queryFn: async () => {
      const res = await axios.get(`/api/datasets/${draftId}/draft`);
      const workflows = await axios.get(
        `/api/infra/datasets/${draftId}/workflows?page_size=1000`,
      );

      return {
        draft: res.data,
        workflows: workflows.data,
      };
    },
    refetchInterval: 15_000,
  });
};
